<template lang="pug">
  .reservation-schedule-help
    img.help-icon(:id="_popoverId" src="../../assets/help.svg")
    b-popover(:target="_popoverId" triggers="hover")
      template(v-slot:title) 面会設定の表示について
      span
        span.cant ×
        span ：面会予約不可
      br
      span
        span.can 〇
        span ：面会予約可
      br
      span
        span.reserved 予約有
        span ：家族からの面会予約有り
      br
      span
        span.cant ×
        span をクリックすると
        span.can 〇
        span に、
        span.can 〇
        span をクリックすると
        span.cant ×
        span に変更できます。
      br
      span
        span 変更後は「登録」もしくは「更新」をクリックすると設定が反映されます。
      br
      span
        span ご家族が予約可能な日時は、訪問面会の基本設定で設定した家族ユーザーの予約可能日以降になります。設定日以前の日は
        span.can 〇
        span であってもご家族は予約できません。
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ReservationScheduleHelp extends Vue {
  @Prop({
    type: String,
    default: () => {
      return "reservation-schedule-help";
    }
  })
  private popoverId!: string;

  get _popoverId(): string {
    return this.popoverId;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

.help-icon {
  // このアイコンはmix-inのsvg-icon()を使用するとただの○に潰れてしまうのでsvg自体で色を指定している
  width: 28px;
  height: 28px;
}
.cant {
  font-size: 20px;
  font-weight: bold;
  color: $font-disable-font-color;
}
.can {
  font-weight: bold;
  color: $font-key-color;
}
.reserved {
  color: $font-strong-color;
}

.question-circle {
  margin: 0;
  color: $font-key-color;
  font-size: 22px !important;
}
.option-text {
  color: $errormessage-font-color;
}
</style>
